'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Formatting'];
module.exports = angular.module('AVRO.Dashboard.SummaryPanel', dependencies).directive('rmDashboardSummaryPanel', require('./directives/DashboardSummaryPanelDirective')).controller('DashboardSummaryPanelController', require('./controllers/DashboardSummaryPanelController'));